export default __webpack_public_path__ + "static/media/todo-grey.e56e07eb.svg";